/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Table } from "antd";
import { onShowSizeChange } from "./pagination";

const Datatable = ({ columns, dataSource, pagination, ...restProps }) => {

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  return (
    <Table
      className="table datanew dataTable no-footer"
      rowSelection={rowSelection}
      columns={columns}
      dataSource={dataSource}
      pagination={pagination} // Pass the pagination prop here
      rowKey={(record) => record.id}
      {...restProps} // Forward any additional props
    />
  );
};

export default Datatable;